import React from 'react'
import { useNavigate } from "react-router-dom";

function AddCompanyForm() {
    const navigate = useNavigate();
    return (
        <main>
          <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
            <div className="flex justify-between items-center mb-4">
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-[#7B20C7] text-2xl"> Add Company</h1>
              </div>
            </div>
            <div className="w-full">
              <form action="" className="w-full" onSubmit={e => e.preventDefault()}>

                <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
                  <label htmlFor="" className="w-full">
                    <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                      Name
                    </span>
                    <div className="mb-2 pt-0">
                      <input
                        type="text"
                        placeholder="Unit Name"
                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        required/>
                    </div>
                  </label>

            <label htmlFor="" className="w-full">
              <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
              Address
              </span>
              <div className="mb-2 pt-0">
                <textarea type="text"rows="3" placeholder="Address"className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full " required/>
              </div>
            </label>


                 
                </div>

                <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
                  <label htmlFor="" className="w-full">
                    <span className="text-[#7B20C7] text-sm mb-2 -mt-4 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                      Email
                    </span>
                    <div className="mb-2 pt-0">
                      <input
                        type="text"
                        placeholder="Email"
                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        required/>
                    </div>
                  </label>

            <label htmlFor="" className="w-full ">
              <span className="text-[#7B20C7] text-sm mb-2 font-bold">
              Description
              </span>
              <div className="mb-2 pt-0">
                <textarea rows="3" type="text" placeholder="Enter..."className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full " required/>
              </div>
            </label>


                 
                </div>

                <div className="flex flex-col md:flex-row  gap-y-2 w-full ">
                  <label htmlFor="" className="w-full md:w-2/4 ">
                    <span className="text-[#7B20C7] text-sm mb-2 -mt-4 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                      Phone
                    </span>
                    <div className="mb-2 -pt-1">
                      <input
                        type="text"
                        placeholder="Phone"
                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        required/>
                    </div>
                  </label>


                 
                </div>

                <div className="flex flex-col md:flex-row  gap-y-2 w-full">
                  <label htmlFor="" className="w-full md:w-2/4 ">
                    <span className="text-[#7B20C7] text-sm mb-2 -mt-4 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                      Password
                    </span>
                    <div className="mb-2 pt-0">
                      <input
                        type="text"
                        placeholder="Password"
                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        required/>
                    </div>
                  </label>


                 
                </div>

                <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
                <div className="flex gap-2">
                  <button
                    className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                    type="submit"
                  >
                    Submit
                  </button>
                  <button
                    className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </div>
              </form>
            </div>
                

          </div>
        </main>
      );
}

export default AddCompanyForm